import { render, staticRenderFns } from "./RefuseRequestController.vue?vue&type=template&id=3974c8e9&scoped=true"
import script from "./RefuseRequestController.vue?vue&type=script&lang=ts"
export * from "./RefuseRequestController.vue?vue&type=script&lang=ts"
import style0 from "./RefuseRequestController.vue?vue&type=style&index=0&id=3974c8e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3974c8e9",
  null
  
)

export default component.exports